export enum AccessType {
  DISCLOSURE = 'ACCESS_TYPE:DISCLOSURE',
  ACCESS_CODE = 'ACCESS_TYPE:ACCESS_CODE',
  ACCESS_CODE_SINGLE_USE = 'ACCESS_TYPE:ACCESS_CODE_SINGLE_USE',
  ID_CODE = 'ACCESS_TYPE:ID_CODE',
  REG_CODE = 'ACCESS_TYPE:REG_CODE',
}
